var map = {
	"./blue/logo.png": "./src/assets/image/blue/logo.png",
	"./purple/logo.png": "./src/assets/image/purple/logo.png",
	"./red/logo.png": "./src/assets/image/red/logo.png",
	"./yellow/logo.png": "./src/assets/image/yellow/logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/logo\\.png$";